<template>
  <div
    id="delivery-order-history"
    class="page-content"
  >
    <div class="row">
      <div class="col-12">
        <grocery-search />

        <grocery-details />

        <grocery-events />

        <grocery-transactions />

        <search-grocery-need-love />

        <gourmet-history />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, defineAsyncComponent } from 'vue';
import { useRoute } from 'vue-router';

import util from '@/Utils/util';

const GrocerySearch = defineAsyncComponent(() => import('./Grocery/GrocerySearch.vue') as any);
const GroceryDetails = defineAsyncComponent(() => import('./Grocery/GroceryDetails.vue') as any);
const GroceryEvents = defineAsyncComponent(() => import('./Grocery/GroceryEvents.vue') as any);
const GroceryTransactions = defineAsyncComponent(() => import('./Grocery/Transactions.vue') as any);
const SearchGroceryNeedLove = defineAsyncComponent(() => import('./Grocery/SearchGroceryNeedLove.vue') as any);
const GourmetHistory = defineAsyncComponent(() => import('./Gourmet/GourmetHistory.vue') as any);

onMounted(async () => {
  const route = useRoute();
  await nextTick();
  util.moveScrollComponent(route.hash);
});
</script>
